export const errorTexts = {
  overlappingTime: 'WEARABLES.USER_PAGE.ERRORS.OVERLAPPING',
  emptyTaskName: 'WEARABLES.USER_PAGE.ERRORS.EMPTY',
  timeEndBiggerThanTimeStart: 'WEARABLES.USER_PAGE.ERRORS.TIME_BIGGER',
  emptyTimeField: 'WEARABLES.USER_PAGE.ERRORS.TIME_EMPTY',
};
